<script setup>
    import {
        Link,
        usePage
    } from '@inertiajs/vue3';
    import {
        computed
    } from 'vue';
    import {
        trans
    } from 'laravel-vue-i18n';

    const props = defineProps({
        status: {
            type: Number,
            required: true,
        },
        user: {
            type: Object,
        }
    })

    const title = computed(() => {
        return {
            503: trans('common.error_massage.service_unavailable'),
            500: trans('common.error_massage.server_error'),
            404: trans('common.error_massage.page_not_found'),
            403: trans('common.error_massage.forbidden'),
        } [props.status]
    })

    const description = computed(() => {
        return {
            503: trans('common.error_massage.503_error'),
            500: trans('common.error_massage.500_error'),
            404: trans('common.error_massage.404_error'),
            403: trans('common.error_massage.403_error'),
        } [props.status]
    })

    const page = usePage();
    const isUser = page.props.auth.user ? true : false;

</script>

<template>
    <div class="error-page">
        <div class="container d-md-flex align-items-center justify-content-center center-div-text">
            <div class="info-body text-center image-center-ipad d-none d-md-block">
                <img src="/assets/images/01FA04aObserve_Reverse_Cutout.png" class="image-responsive">
            </div>

            <div class="d-block d-md-none">
                <div class="info-body text-center h-100vh image-center-ipad">
                    <img src="/assets/images/01FA04aObserve_Reverse_Cutout.png" class="image-responsive">
                    <img src="/assets/images/DeepRoots-Logo_Black.png" class="logo-width ml-1 mt-4">
                </div>
            </div>

            <div class="text-center px-0 px-md-4">
                <div class="d-none d-md-block">
                    <img src="/assets/images/DeepRoots-Logo_Black.png" class="logo-width">
                </div>

                <h2 class="line1-text mt-4">
                    {{$t('common.404_error.heading')}}
                </h2>

                <h2 class="oops-font fw-bold">
                    {{$t('common.404_error.oops_text')}}
                </h2>

                <h2 class="line2-text mb-0">
                    {{$t('common.404_error.subtext1')}}
                </h2>

                <h2 class="line2-text mb-0">
                    {{$t('common.404_error.subtext2')}}
                </h2>

                <a v-if="isUser && $page.props.auth.dashboard_url.includes('/junior-high')" :href="$page.props.auth.dashboard_url" type="submit"
                    class="btn btn-green mt-4 p-2 font-25px">
                    {{$t('common.404_error.return_btn')}}
                </a>
                <Link v-else-if="isUser" :href="$page.props.auth.dashboard_url" type="submit"
                    class="btn btn-green mt-4 p-2 font-25px">
                {{$t('common.404_error.return_btn')}}
                </Link>

                <Link v-else :href="route('/')" type="submit" class="btn btn-green mt-4 p-2 font-25px">
                {{$t('common.404_error.return_btn')}}
                </Link>
            </div>
        </div>
    </div>
</template>

<style>
    .center-div-text {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .line1-text {
        font-size: 20px;
    }

    .line2-text {
        font-size: 20px;
    }

    .oops-font {
        font-size: 40px;
        margin-bottom: 1rem;
    }

    .h-100vh {
        height: 20vh;
    }

    .mr-b-5rem {
        padding-bottom: 3rem;
    }

    .font-30px {
        font-size: 20px !important;
    }

    .font-25px {
        font-size: 20px !important;
    }

    .logo-width {
        width: 40%;
    }

    .image-responsive {
        max-height: 100%;
        height: auto;
    }

    @media (min-width: 767px) {
        .image-responsive {
            max-height: 70vh;
            height: 70vh;
        }
        .line1-text {
            font-size: 25px;
            color: #383838;
            font-weight: 500;
        }

        .line2-text {
            font-size: 30px;
            color: #383838;
            font-weight: 500;
        }

        .oops-font {
            font-size: 50px;
            margin-top: 20px;
            color: #383838;
        }

        .h-100vh {
            height: 100vh;
        }

        .logo-width {
            width: 35%;
        }

        .mr-b-5rem {
            padding-bottom: 7rem;
        }

        .font-25px {
            font-size: 25px !important;
        }
    }

    @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
        .image-responsive {
            height: 40vh;
            max-height: 40vh;
        }

        .image-center-ipad {
            display: flex !important;
            align-items: center;
        }

        .line1-text {
            font-size: 20px;
        }

        .line2-text {
            font-size: 20px;
        }
    }

</style>
